module.exports = __webpack_public_path__ + "static/media/image-10.1ccb5ac3.png";